import { Anchor, Box, Grid, Group, Stack, Text } from "@mantine/core"
import { HelpHover } from "@tfg/ui"
import { Link } from "react-router-dom"

export interface ProgresBoxSection {
  color: string
  width: number
  text: string
  label?: string
  textColor?: string
  href?: string
}

interface ProgressBoxProps {
  sections: ProgresBoxSection[]
  total: number
  helpHoverText: string
  helpHoverRedirectTo?: string
}

export const ProgressBox = ({
  sections,
  total,
  helpHoverText,
  helpHoverRedirectTo,
}: ProgressBoxProps) => {
  return (
    <Stack bg="white">
      <Grid align="flex-end">
        <Grid.Col span={9}>
          <Box p={0}>
            <Group justify="space-between" w="100%">
              {sections.map((section) => {
                const TextComponent = (
                  <Text fw={600} c={section.color} key={section.label}>
                    {section.label}
                  </Text>
                )
                if (section.href) {
                  return (
                    <Anchor
                      key={section.label}
                      href={section.href}
                      target="_blank"
                    >
                      {TextComponent}
                    </Anchor>
                  )
                } else {
                  return TextComponent
                }
              })}
            </Group>
            {sections.map(
              (section, index) =>
                section.width > 0 && (
                  <Box
                    key={index}
                    style={{
                      display: "inline-block",
                      whiteSpace: "nowrap",
                    }}
                    w={`${section.width}%`}
                  >
                    <Group
                      style={{
                        height: "40px",
                        borderTopLeftRadius:
                          index == 0 || section.width == 100 ? "5px" : "0px",
                        borderBottomLeftRadius:
                          index == 0 || section.width == 100 ? "5px" : "0px",
                        borderTopRightRadius:
                          index == sections.length - 1 || section.width == 100
                            ? "5px"
                            : "0px",
                        borderBottomRightRadius:
                          index == sections.length - 1 || section.width == 100
                            ? "5px"
                            : "0px",

                        color: "white",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                      }}
                      bg={section.color}
                      align="center"
                      justify="center"
                    >
                      <Text c={section.textColor ? section.textColor : "white"}>
                        <strong>{section.text}</strong>
                      </Text>
                    </Group>
                  </Box>
                )
            )}
          </Box>
        </Grid.Col>
        <Grid.Col span={3}>
          <Group gap={0}>
            <Text fz="lg" c="green">
              <strong>{total} Total</strong>
            </Text>
            <HelpHover>
              {helpHoverRedirectTo ? (
                <Link to={helpHoverRedirectTo}>
                  <Anchor>{helpHoverText}</Anchor>
                </Link>
              ) : (
                <Text>{helpHoverText}</Text>
              )}
            </HelpHover>
          </Group>
        </Grid.Col>
      </Grid>
    </Stack>
  )
}
